export type BillingErrorCode =
  | "VALIDATION_ERROR"
  | "FOLIO_NOT_FOUND"
  | "PAYMENT_NOT_FOUND"
  | "PAYMENT_OVERALLOCATION"
  | "REFUND_EXCEEDS_PAYMENT"
  | "FISCAL_INTEGRATION_FAILED"
  | "INVOICE_GENERATION_FAILED";

export type BillingErrorShape = {
  name: "BillingServiceError";
  code: BillingErrorCode;
  message: string;
  fieldErrors?: Record<string, string>;
};

export function createBillingError(
  code: BillingErrorCode,
  message: string,
  fieldErrors?: Record<string, string>
): BillingErrorShape {
  return {
    name: "BillingServiceError",
    code,
    message,
    fieldErrors,
  };
}

export function isBillingServiceError(error: unknown): error is BillingErrorShape {
  return Boolean(
    error &&
    typeof error === "object" &&
    "name" in error &&
    "code" in error &&
    (error as { name?: string }).name === "BillingServiceError"
  );
}

export function toBillingErrorResponse(error: unknown) {
  if (isBillingServiceError(error)) {
    return {
      ok: false as const,
      code: error.code,
      message: error.message,
      fieldErrors: error.fieldErrors,
    };
  }

  return {
    ok: false as const,
    code: "VALIDATION_ERROR" as const,
    message: "Billing operation failed.",
  };
}
